module.exports = __webpack_public_path__ + "static/media/visual-timer.d3338250.svg";